import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'
import type { RouterContext } from '@/router'
import { Button } from '@/components/ui/button'

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => (
    <>
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-50 focus:rounded-control focus:bg-brand focus:px-4 focus:py-2 focus:text-ink"
      >
        Skip to content
      </a>
      <Outlet />
    </>
  ),
  notFoundComponent: () => (
    <div className="mx-auto max-w-md p-8 text-center">
      <h1 className="text-3xl uppercase">Page not found</h1>
      <p className="mt-2 text-fg-muted">That page does not exist.</p>
      <Button asChild className="mt-6">
        <a href="/">Go home</a>
      </Button>
    </div>
  ),
  errorComponent: ({ error, reset }) => (
    <div className="mx-auto max-w-md p-8 text-center">
      <h1 className="text-3xl uppercase">Something went wrong</h1>
      <p className="mt-2 text-fg-muted">
        Nothing you typed has been lost. Try again, or check your connection.
      </p>
      <p className="mt-2 text-sm text-fg-muted">
        {error instanceof Error ? error.message : String(error)}
      </p>
      <Button className="mt-6" onClick={reset}>
        Try again
      </Button>
    </div>
  ),
})
